import "core-js/modules/es.parse-int.js";
jQuery(document).ready(function ($) {
  function adjustWishlistCounter() {
    var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '+';
    var currentCount = parseInt(jQuery("span.header-wishlist-icon").attr('data-icon-label'));
    switch (operation) {
      case '+':
        currentCount++;
        break;
      case '-':
        currentCount--;
        break;
    }
    $("span.header-wishlist-icon").attr('data-icon-label', currentCount);
  }
  jQuery(document).on('click', '.add_to_wishlist.single_add_to_wishlist, .wishlist-icon:not(.displayHeart) .wishlist-button', function () {
    jQuery(this).closest('.wishlist-icon').addClass('displayHeart');
    adjustWishlistCounter();
  });
  jQuery(document).on('click', '.yith-wcwl-add-to-wishlist .delete_item, .wishlist-icon.displayHeart .wishlist-button', function () {
    jQuery(this).closest('.wishlist-icon').removeClass('displayHeart');
    adjustWishlistCounter('-');
  });
  jQuery(document).on('click', '.remove_from_wishlist', function () {
    adjustWishlistCounter('-');
  });
});